module.exports = __webpack_public_path__ + "static/media/Exlerete-your-career.9dd64e01.png";